export interface Email {
  email: string;
  default: boolean;
}
